import { render, staticRenderFns } from "./AccessPreRequestLoan.vue?vue&type=template&id=4bbbcb35&scoped=true&"
import script from "./AccessPreRequestLoan.vue?vue&type=script&lang=js&"
export * from "./AccessPreRequestLoan.vue?vue&type=script&lang=js&"
import style0 from "./AccessPreRequestLoan.vue?vue&type=style&index=0&id=4bbbcb35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbcb35",
  null
  
)

export default component.exports